import { ComponentPropsWithoutRef } from 'react';

import { Box, Shimmer } from '@betterment/samba-react';

import type { SystemStyleObject } from '@betterment/samba-styled-system/types';

interface ColumnShimmerProps extends Omit<ComponentPropsWithoutRef<'div'>, 'children'> {
  columns: 1 | 2;
  height?: SystemStyleObject['height'];
  leadingWidth?: SystemStyleObject['width'];
  trailingWidth?: SystemStyleObject['width'];
  css?: SystemStyleObject;
}

export const ColumnShimmer: React.FC<ColumnShimmerProps> = ({
  columns,
  height = '30px',
  leadingWidth = '120px',
  trailingWidth = '120px',
  css: cssOverride,
  ...divProps
}) => {
  if (columns === 1) {
    return (
      <Box css={{ display: 'flex', alignItems: 'center', ...cssOverride }} {...divProps}>
        <Shimmer css={{ height, width: '100%' }} />
      </Box>
    );
  }

  return (
    <Box css={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', ...cssOverride }} {...divProps}>
      <Shimmer css={{ height, width: leadingWidth }} />
      <Shimmer css={{ height, width: trailingWidth }} />
    </Box>
  );
};
